import { render, staticRenderFns } from "./OverOns.vue?vue&type=template&id=165c7779&"
import script from "./OverOns.vue?vue&type=script&lang=js&"
export * from "./OverOns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports